import { Plan } from './plan.model';
import { OOSPlan } from './oosPlan.model';
import { Contribution } from './contribution.model'
import { LiteWrapActiveCarrier } from './select-wrap-carrier.model';
export class Carrier {
  constructor() {
    this.Plans = new Array<Plan>();
    this.OOSPlans = new Array<OOSPlan>();
    this.Contribution = new Contribution();
  }
  CarrierId: string;
  PayPeriodTypeId: number = 1;  //By Default value will be "Monthly"
  CarrierName: string;
  CarrierPackageId: string;
  CarrierImageUri: String = "";
  CarrierPackageName: string;
  MaxPlansAllowed: number;
  MinPlansAllowed: number;
  PackageRuleInstanceId: number;
  Plans: Plan[];
  OOSPlans: OOSPlan[];
  Contribution: Contribution;
  Networks: string;
  OrionCarrierId: string;
  LiteWrapCarrier: LiteWrapActiveCarrier[];
}

export class CarrierLogoRequest {
  CarrierIds: number[] = [];
  OrionCarrierIds: string[] = [];
}
